import React from 'react';
import { Eye, Target, ShieldCheck } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function ComoPensamos() {
  const {
    ref: quoteRef,
    isVisible: isQuoteVisible
  } = useScrollAnimation({
    threshold: 0.2
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  return <section id="como-pensamos" className="py-10 md:py-14 bg-white" data-id="element-11">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-12">
        <div className="text-center mb-8" data-id="element-13">
          <span className="font-body text-xs uppercase tracking-widest text-silver-dark" data-id="element-14">
            Cómo pensamos
          </span>
        </div>

        {/* Quote Block */}
        <div ref={quoteRef} className={`max-w-4xl mx-auto text-center mb-10 relative scroll-animate ${isQuoteVisible ? 'is-visible' : ''}`} data-id="element-15">
          <span className="absolute -top-12 md:-top-16 left-1/2 -translate-x-1/2 font-heading text-7xl md:text-9xl text-silver-main/20 leading-none select-none" data-id="element-16">
            "
          </span>
          <blockquote className="relative z-10" data-id="element-17">
            <p className="font-heading italic text-2xl md:text-4xl text-petrol-dark leading-relaxed mb-5" data-id="element-18">
              No puedes conectar los puntos mirando hacia adelante; solo puedes
              hacerlo mirando hacia atrás. Así que tienes que confiar en que los
              puntos se conectarán de alguna forma en el futuro.
            </p>
            <footer className="font-body text-sm text-silver-dark uppercase tracking-wider" data-id="element-19">
              — Steve Jobs
            </footer>
          </blockquote>
        </div>

        {/* Principles Cards */}
        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-8 scroll-animate ${areCardsVisible ? 'is-visible' : ''}`} data-id="element-20">
          {/* Card 1 */}
          <div className="bg-white border border-silver-main/30 rounded-lg p-6 md:p-8 hover:shadow-md transition-shadow duration-300" data-id="element-21">
            <Eye className="w-8 h-8 text-silver-dark mb-5" strokeWidth={1.5} data-id="element-22" />
            <h3 className="font-body font-semibold text-xl text-petrol-dark mb-3" data-id="element-23">
              Realismo en el diagnóstico
            </h3>
            <p className="font-body text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-24">
              Innovación con prudencia institucional. Sumamos herramientas
              nuevas sin desconocer que, en el mundo público y regulado, la
              estabilidad también es un activo.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white border border-silver-main/30 rounded-lg p-6 md:p-8 hover:shadow-md transition-shadow duration-300" data-id="element-25">
            <Target className="w-8 h-8 text-silver-dark mb-5" strokeWidth={1.5} data-id="element-26" />
            <h3 className="font-body font-semibold text-xl text-petrol-dark mb-3" data-id="element-27">
              Ambición en el diseño
            </h3>
            <p className="font-body text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-28">
              Acompañamos cambios complejos para migrar hacia modelos más
              responsables y sostenibles, sin perder foco en competitividad,
              gobernanza y consistencia interna.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white border border-silver-main/30 rounded-lg p-6 md:p-8 hover:shadow-md transition-shadow duration-300" data-id="element-29">
            <ShieldCheck className="w-8 h-8 text-silver-dark mb-5" strokeWidth={1.5} data-id="element-30" />
            <h3 className="font-body font-semibold text-xl text-petrol-dark mb-3" data-id="element-31">
              Disciplina en la ejecución
            </h3>
            <p className="font-body text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-32">
              Excelencia como método, calidad de entrega y trazabilidad.
              Estándar ejecutivo, claridad para decidir, profundidad para
              sostener y precisión para implementar.
            </p>
          </div>
        </div>

        {/* Closing Paragraph */}
        <div className="max-w-3xl mx-auto text-center" data-id="element-33">
          <p className="font-body text-base md:text-lg text-gray-600 leading-relaxed" data-id="element-34">
            Entendemos la transformación como un proceso que exige alta
            performance no solo técnica, sino también en relaciones humanas:
            liderazgo, acuerdos, incentivos y confianza. Nuestro equipo combina
            experiencia profunda con pensamiento estratégico y creatividad
            aplicada.
          </p>
        </div>
      </div>
    </section>;
}